import React from "react";
import { resolveExercisePicto } from "../utils/exercisePicto";

// Vignette d'exercice avec preview agrandie au survol.
// - Passe soit `exercise` (objet ex. { nomExercice, imageUrl }), soit `url` direct.
// - Fallback silencieux si l'image ne charge pas.
export default function ExerciseThumb({ exercise, url: urlProp, size = 32, previewSize = 260 }) {
	const [imgError, setImgError] = React.useState(false);
	const url = urlProp || resolveExercisePicto(exercise);

	if (!url || imgError) {
		return (
			<div
				className="exercise-thumb exercise-thumb-empty"
				style={{ width: size, height: size }}
			/>
		);
	}

	return (
		<span className="exercise-thumb-wrap" style={{ width: size, height: size }}>
			<img
				src={url}
				alt=""
				className="exercise-thumb"
				style={{ width: size, height: size }}
				onError={() => setImgError(true)}
			/>
			<span
				className="exercise-thumb-popup"
				style={{ width: previewSize, height: previewSize }}
			>
				<img src={url} alt="" />
			</span>
		</span>
	);
}
